export default {
  language: 'EN',
  search: '搜索',
  expand: '展开',
  collapse: '收起'
}; 